import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

export const StyledInfoWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 310px;
  gap: 24px;
  height: 100%;
`;

interface StyledInfoImgProps {
  $imageWidth: number;
  $imageHeight: number;
}

export const StyledInfoImg = styled.img<StyledInfoImgProps>`
  width: ${(p) => p.$imageWidth}px;
  height: ${(p) => p.$imageHeight}px;
`;

export const StyledInfoTextWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const StyledInfoHeaderDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  line-height: 20px;
  max-width: 480px;
  white-space: normal;
  text-align: center;
`;

export const StyledInfoBodyDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
  text-align: center;
  line-height: 21px;
`;

export const StyledButtonWrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

/*
 * Props.
 */

interface AnalyticsInfoStateProps {
  className?: string;
  body: ReactNode;
  imgPath: string;
  imgWidth?: number;
  imgHeight?: number;
  title: string;
  actions?: ReactNode;
}

/*
 * Component.
 */

export const AnalyticsInfoState: FC<AnalyticsInfoStateProps> = ({
  className,
  body,
  imgPath,
  title,
  actions,
  imgWidth = 92,
  imgHeight = 67,
}) => (
  <StyledInfoWrapperDiv className={className}>
    <StyledInfoImg $imageWidth={imgWidth} $imageHeight={imgHeight} src={imgPath} alt={title} />
    <StyledInfoTextWrapperDiv>
      <StyledInfoHeaderDiv>{title}</StyledInfoHeaderDiv>
      <StyledInfoBodyDiv>{body}</StyledInfoBodyDiv>
    </StyledInfoTextWrapperDiv>
    {actions && <StyledButtonWrapperDiv>{actions}</StyledButtonWrapperDiv>}
  </StyledInfoWrapperDiv>
);
